import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import ja from 'vuetify/lib/locale/ja'
import i18n from '@/i18n'
import '@/sass/overrides.sass'

Vue.use(Vuetify)

const theme = {
  // primary: '#4CAF50',
  // primary: '#ff9800',
  // primary: '#276fdc',
  primary: '#4CAF50',
  secondary: '#9C27b0',
  accent: '#9C27b0',
  info: '#00CAE3',
}

export default new Vuetify({
  lang: {
    locales: { ja },
    current: 'ja',
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
})
